import { YomiriDiscoverView } from './YomiriDiscoverView.tsx';
import type { YomiriManga } from '../../types/extension.ts';

interface Props {
  onOpenManga?: (
    mangaId: string,
    chapterId?: string,
    manga?: YomiriManga,
  ) => void;
  onNavigate?: (view: string) => void;
}

/** Manga discovery and catalog view unified with OTT design & source filter */
export function YomiriMangaEntry(props: Props) {
  return <YomiriDiscoverView type="MANGA" onOpenManga={props.onOpenManga} />;
}
